<template>
  <div class="announcement-card">
    <div class="d-flex justify-content-center align-items-center modal-title-head">        
      <div class="title-head">
        <p style="text-align:center">{{ $t('announcements.announcementPreview') }}</p>
      </div>
      <svg @click="$bvModal.hide('announcement-data-modal')" class="closeAnnouncementData" width="22"
        height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"> 
          <path d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z" 
          fill="#F46A6A"/>
      </svg>
    </div>
      <div>
        <b-spinner style="inset-inline-end: 48%;top: 60%;" v-if="isLoading" variant="secondary" role="status" size="sm" class="wizard-spinner "/>
        <div v-else>
          <p class="announcement-title">{{ title }}</p>
          <div class="d-flex justify-content-center flex-wrap" style="row-gap: 8px">
              <span v-if="urgent" class="urgent-announcement-user-type">{{ $t('announcements.urgent') }}</span>
              <span v-for="(userType, i) in userTypes" :key="i" class="announcement-user-type">{{ userType }}</span>
              <span v-for="(area, i) in areas" :key="i" class="announcement-user-type">{{ area }}</span>
          </div>
          <div class="announcement-description-container">
              <p class="announcement-description" v-html="description"></p>
          </div>
          <div v-if="url" class="announcement-url">
            <a target="_blank" :href="url" >{{ url }} </a>
          </div>
          <div style="display: grid; gap: 16px">
            <div class="announcement-data mt-32">
              <p>{{ $t('announcements.publishTime') }}: </p>
              <p>{{ publishDate }}</p>
            </div>

            <div class="announcement-data mt-32">
              <p>{{ $t('announcements.expiryTime') }}: </p>
              <p>{{ expiryDate }}</p>
            </div>

            <div class="announcement-data mt-18">
              <p style="white-space: nowrap;">{{ $t('announcements.grid.createdAt') }}: </p>
              <p style="white-space: nowrap;">{{ createdAt }} {{ $t('common.by').toLowerCase() }} ({{ createdby }})</p>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import moment from "moment";

  export default {
    name: "viewAnnouncementData",
    components: { 

    },
    data() {
      return {
        title : null,
        urgent : false,
        userTypes : [],
        areas: [],
        description : null,
        url : null,
        publishDate : null,
        expiryDate : null,
        createdAt : null,
        createdby : null,
        isLoading : false,
      };
    },
    methods: {
      ...mapActions("announcements", [ "fetchAnnouncement" ]),
    },
    computed: {
      ...mapGetters("users", ["getModalState"]),
      ...mapGetters("modal", ["getModalInfo"]),
    },
    watch: {
        getModalState(state) {
          state && this.$bvModal.hide("announcement-data-modal");
        },
      },
    async beforeMount() {
      this.isLoading = true,
      console.log('this.getModalInfo', this.getModalInfo);
      if(this.getModalInfo){
        await this.fetchAnnouncement(this.getModalInfo).then((data)=>{
          this.title = data.title;
          this.description = JSON.parse(data.description);
          this.url = data.url;
          this.urgent = data.urgent ? true : false;
          if(data.userTypes){
            data.userTypes.map((userType)=>{
                this.userTypes.push(userType.name);
            });
          }
          if(data.areas){
            data.areas.map((userType)=>{
                this.areas.push(userType.name);
            });
          }
          this.publishDate = moment(data.publish_date).format('DD/MM/YYYY - hh:mm A');
          this.expiryDate = data.expiry_date ? moment(data.expiry_date).format('DD/MM/YYYY - hh:mm A') : 'Never';
          this.createdAt = moment(data.created_at).format('DD/MM/YYYY - hh:mm A');
          this.createdby = data.created_by.fullName;
          this.isLoading = false;
        });

      }
    },
    destroyed(){
      this.title = null;
      this.description = null;
      this.url = null;
      this.urgent = null;
      this.userTypes = null;
      this.areas = null;
      this.publishDate = null;
      this.expiryDate = null;
      this.createdAt = null;
      this.createdby = null;
      this.isLoading = false;
    },
  };
</script>

<style lang="scss">
  div#announcement-data-modal {
    div#announcement-data-modal___BV_modal_content_ {
      width: 500px!important;
      background: #FFFFFF;
      box-shadow: 0px 1px 40px 3px rgb(0 0 0 / 5%);
      border-radius: 26px !important;
      div#announcement-data-modal___BV_modal_body_{
        padding: 40px 32px!important;
        .modal-title-head{
            .title-head {
              font-weight: 700;
              font-size: 16px;
              line-height: 20px; 
              margin:0px 0 40px 0;
              color: #000000;
              p{
                font-weight: 700;
                font-size: 16px;
                margin-bottom: 0px!important;
              }
            }
        }

        .closeAnnouncementData{
          position: absolute;
          top: 32px;
          inset-inline-end: 32px;
          cursor: pointer;  
        }


        .announcement-title{
          width: 416px;
          color: #4A4A4A;
          text-align: center;
          font-size: 16px;
          font-weight: 600;
          line-height: normal;
          margin: 0px 0 32px 0;
        }
        .announcement-user-type {
            margin-inline-end: 8px;
            display: inline-flex;
            height: 28px;
            padding-top: 11px;
            padding-inline-end: 11px;
            padding-bottom: 11px;
            padding-inline-start: 14px;
            align-items: center;
            flex-shrink: 0;
            border-radius: 31px;
            background: #E5E5E5;
            color: #4A4A4A;
            font-size: 14px;
            font-weight: 500;
            line-height: 17px;
            letter-spacing: 0.25px;
            &:last-child{
              margin-inline-end: 0px!important;
            }
        }

        .urgent-announcement-user-type {
            margin-inline-end: 8px;
            display: inline-flex;
            height: 28px;
            padding-top: 11px;
            padding-inline-end: 11px;
            padding-bottom: 11px;
            padding-inline-start: 14px;
            align-items: center;
            gap: 14px;
            flex-shrink: 0;
            border-radius: 31px;
            background: var(--Error, #F46A6A);
            color: #FFF;
            font-size: 14px;
            font-weight: 500;
            line-height: 17px;
            letter-spacing: 0.25px;
        }
          .announcement-description-container{
            margin-bottom: 32px;
          }
        .announcement-description {
            width: 416px;
            word-break: break-word;
            margin-top: 32px;
            margin-bottom: 32px;
            color: #4A4A4A;
            flex-shrink: 0;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px; 
        }
        
        .announcement-data {
            color: #4A4A4A;
            font-size: 16px;
            margin-bottom: 0px!important;
            line-height: 24px;
            display: flex;
            gap: 3px;
            height: 11px;
            p {
              height: 11px;
              display: flex;
              align-items: center;
            }
        }

        .announcement-url{
          margin-bottom: 32px;
        }
      }
    }
  }
</style>
